import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closure",
  "use": "icon-closure-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-closure\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"17.24 5 12 10.24 6.76 5 5 6.76 10.24 12 5 17.24 6.76 19 12 13.76 17.24 19 19 17.24 13.76 12 19 6.76 17.24 5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol